
<div class="modal-header" translate>Regenerate proxies</div>
<div class="modal-body">
  <regenerate-proxies-options [options]="options" [root]="root" [type]="type"></regenerate-proxies-options>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="start()" [disabled]="!options.proxyProfiles?.length"><i class="far fa-play"></i><span translate>Start</span></button>
  <button class="btn btn-outline-secondary" (click)="modalInstance.dismiss()" translate>Cancel</button>
</div>